import { FONTS } from '../../../../constants/fonts';
import {
    ptFactor,
    SIZE_OPTIONS, sizeScale
} from '../../../../constants/sizes';

const lpTextFontSize = 44 * sizeScale;
const ptTextFontSize = 39 * sizeScale * ptFactor;
const mbTextFontSize = 46 * sizeScale * ptFactor;

export const getTextMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.ACCENT,
        lineHeight: 1
    };
    const em = 4;

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize,
            width: em * lpTextFontSize
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTextFontSize * 0.8,
            width: em * ptTextFontSize * 0.5
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: mbTextFontSize * 0.67,
            width: em * mbTextFontSize * 0.8 * 0.5
        };
    }

    return {
        ...base,
        fontSize: mbTextFontSize,
        width: em * mbTextFontSize
    };
};
